<app-feature-tiles-grid>
  <app-device-features-container
    [header]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.PV_IMMERSION_HEATER' | translate"
    [overlayType]="availableOverlays.PvImmersionHeaterDetails"
    [deviceSelectId]="selectedDeviceId"
  >
    <ng-container feature *ngIf="PvHeaterPowerConsumptionCurrent$ | async | ready as feature">
      <app-feature-tile
        feature
        [label]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.STATE' | translate"
        [value]="feature | value2: featurePropertyKey.status | translatePvImmersionStatus"
        [error]="feature | error"
        isFullWidth="true"
      ></app-feature-tile>

      <app-feature-tile
        feature
        [label]="'+INSTALLATIONS.INSTALLATION.PV_HEATER.CONSUMPTION' | translate"
        [value]="
          feature.properties.value
            ? (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
            : NO_VALUE + ' ' + SUFFIX.kilowatt
        "
        isFullWidth="true"
      ></app-feature-tile>
    </ng-container>
  </app-device-features-container>
</app-feature-tiles-grid>
